module.exports = __webpack_public_path__ + "8a5356e9/img/pwrd-by-sourcery-black.bba9ba41.svg";